var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "fromRequestDetailModal",
      attrs: {
        title: "Detalle Solicitud de Materiales",
        id: "addMaterials",
        size: "xl",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        centered: "",
        "hide-footer": ""
      },
      on: {
        close: function($event) {
          return _vm.onModalClose()
        }
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        { staticClass: "row scroll" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("h5", { staticClass: "text-primary" }, [
              _vm._v(
                " Esta solicitud ha sido creada por " +
                  _vm._s(_vm.requestDetail.name || "-") +
                  " "
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "col-12", staticStyle: { margin: "0 auto" } },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "shadow col-4" },
                  [
                    _c(
                      "vs-list",
                      [
                        _c("vs-list-item", {
                          attrs: {
                            icon: "description",
                            title:
                              _vm.requestDetail.numero.padStart(7, "0") || "-",
                            subtitle: "Folio"
                          }
                        }),
                        _c("vs-list-item", {
                          attrs: {
                            icon: "person",
                            title: _vm.requestDetail.name || "-",
                            subtitle: "Creador"
                          }
                        }),
                        _c("vs-list-item", {
                          attrs: {
                            icon: "event",
                            title:
                              this.$moment(_vm.requestDetail.createdAt).format(
                                "YYYY-MM-DD"
                              ) || "-",
                            subtitle: "Fecha de Creación Solicitud"
                          }
                        }),
                        _c("vs-list-item", {
                          attrs: {
                            icon: "info",
                            title: _vm.requestDetail.statusDescription || "-",
                            subtitle: "Estado Solicitud"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "shadow col-4" },
                  [
                    _c(
                      "vs-list",
                      [
                        _c("vs-list-item", {
                          attrs: {
                            icon: "event",
                            title: _vm.requestDetail.dateRequest || "-",
                            subtitle: "Fecha de Solicitud"
                          }
                        }),
                        _c("vs-list-item", {
                          attrs: {
                            icon: "event",
                            title: _vm.requestDetail.dateRequestEnd || "-",
                            subtitle: "Fecha de Retiro"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "shadow col-4" },
                  [
                    _c(
                      "vs-list",
                      [
                        _c("vs-list-item", {
                          attrs: {
                            icon: "person",
                            title: _vm.requestDetail.request || "-",
                            subtitle: "Nombre Solicitud"
                          }
                        }),
                        _c("vs-list-item", {
                          attrs: {
                            icon: "description",
                            title: _vm.requestDetail.description || "-",
                            subtitle: "Descripción Solicitud"
                          }
                        }),
                        _c("vs-list-item", {
                          attrs: {
                            icon: "attach_money",
                            title:
                              _vm.requestDetail.precioSolicitudTotal || "-",
                            subtitle: "Monto Final"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _c("vs-divider"),
          _c("div", { staticClass: "col-12" }, [
            _c("h5", { staticClass: "text-primary" }, [
              _vm._v(" Detalle Solicitud ")
            ]),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                _vm._l(_vm.requests, function(request) {
                  return _c(
                    "b-list-group",
                    { key: request.id },
                    [
                      _c(
                        "b-list-group-item",
                        {
                          key: request.id,
                          attrs: {
                            "v-b-toggle": "accordion-" + request.id,
                            button: "",
                            role: "tab"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onActiveAccordion(request.id)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-11" }, [
                              _vm._v(" " + _vm._s(request.name) + " ")
                            ]),
                            _c("div", { staticClass: "col-1" }, [
                              _vm.isAccordionOpen &&
                              _vm.activeAccordionId === request.id
                                ? _c("em", {
                                    staticClass: "fa fa-chevron-down"
                                  })
                                : _c("em", { staticClass: "fa fa-chevron-up" })
                            ])
                          ])
                        ]
                      ),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "ml-5 mr-5" },
                          [
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  id: "accordion-" + request.id,
                                  accordion: "my-accordion",
                                  role: "tabpanel",
                                  block: "",
                                  visible:
                                    _vm.isAccordionOpen &&
                                    _vm.activeAccordionId === request.id
                                }
                              },
                              [
                                _c("b-table", {
                                  key: "table-" + request.id,
                                  attrs: {
                                    fields: _vm.fieldMaterialsRequestDetail,
                                    items: request.materials,
                                    "sticky-header": "",
                                    id: "table-" + request.id,
                                    "primary-key": "id",
                                    fixed: "",
                                    responsive: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(categoria)",
                                        fn: function(row) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  row.item.categoria[0]
                                                    .descripcion || ""
                                                ) +
                                                " "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "cell(marca)",
                                        fn: function(row) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  row.item.marca.descripcion
                                                ) +
                                                " "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "cell(precio)",
                                        fn: function(row) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("toCurrency")(
                                                    parseInt(row.item.precio)
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "cell(totalSolicitar)",
                                        fn: function(row) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("toCurrency")(
                                                    parseInt(
                                                      row.item.totalSolicitar
                                                    )
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }